module.exports = __webpack_public_path__ + "img/air_yellow.73ade97c.svg";